import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29b98a62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-item" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "step-item__text-wrapper" }
const _hoisted_4 = { class: "step-item__title" }
const _hoisted_5 = { class: "step-item__text" }

import { getImage } from '@/models/onboarding'
import { TrialStep } from '@/models/onboarding.types'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StepItem',
  props: {
    step: null,
    variant: null
  },
  setup(__props: any) {

const props = __props as {
  step: TrialStep
  variant: 'annual' | 'monthly'
};



const stepIcon = computed(() => {
  if (props.variant === 'monthly') {
    return getImage(props.step.icon.replace('.svg', '-monthly.svg'))
  }
  return getImage(props.step.icon)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["step-item__icon-wrapper", { 'step-item__icon-wrapper--monthly': __props.variant === 'monthly' }])
    }, [
      _createElementVNode("img", {
        src: _unref(stepIcon),
        class: "step-item__icon"
      }, null, 8, _hoisted_2)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.step.day), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(__props.step.text), 1)
    ])
  ]))
}
}

})